import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import SalesCatalystCompetitionInput from './SalesCatalystCompetitionInput';
import SalesCatalystCompetitionBubbleChart from './SalesCatalystCompetitionBubbleChart';
import SalesCatalystCompetitionColumnChart from './SalesCatalystCompetitionColumnChart';
import SalesCatalystCompetitionComparisonTable from './SalesCatalystCompetitionComparisonTable';
import * as salesCatalystActions from '../../../actions/salesCatalystActions';
import { SC_COMPETITORS_ACTIVITIES, SC_TARGET_MARKET, SC_COMPETITORS,
  SC_COMPETITORS_COMPARISON } from '../../../constants';
import { createStrengthsWeaknessesList, createActivitiesList } from '../../../util/SalesCatalystUtils';

class SalesCatalystCompetition extends React.Component {
  constructor(props) {
    super(props);
    const { dataSelection, bubbleGraphData, columnGraphData, comparisonTableData,
       activitiesTemplateList } = this.props;
    this.state = {
      graphDataInfo: bubbleGraphData,
      columnGraphDataInfo: columnGraphData,
      comparisonTableDataInfo: comparisonTableData,
      strengthsWeaknessesList: {
        strengths: createStrengthsWeaknessesList('Strengths', dataSelection),
        weaknesses: createStrengthsWeaknessesList('Weaknesses', dataSelection),
      },
      activitiesListdata: createActivitiesList(activitiesTemplateList),
    };
  }

  componentDidMount() {
    const { competitionDataOnScreen, bubbleGraphData,
      columnGraphData, comparisonTableData } = this.props;
    if (competitionDataOnScreen &&
      (_.isEmpty(bubbleGraphData) || _.isEmpty(columnGraphData) ||
       _.isEmpty(comparisonTableData))) {
      this.fetchAllCharts();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { competitionDataOnScreen, bubbleGraphData, columnGraphData,
      comparisonTableData, dataSelection, activitiesTemplateList } = this.props;
    if (bubbleGraphData !== nextProps.bubbleGraphData) {
      this.setState({
        graphDataInfo: nextProps.bubbleGraphData,
      });
    }
    if (columnGraphData !== nextProps.columnGraphData) {
      this.setState({
        columnGraphDataInfo: nextProps.columnGraphData,
      });
    }
    if (comparisonTableData !== nextProps.comparisonTableData) {
      this.setState({
        comparisonTableDataInfo: nextProps.comparisonTableData,
      });
    }
    if (!competitionDataOnScreen && nextProps.competitionDataOnScreen) {
      this.setState({
        strengthsWeaknessesList: {
          strengths: createStrengthsWeaknessesList('Strengths', dataSelection),
          weaknesses: createStrengthsWeaknessesList('Weaknesses', dataSelection),
        },
        activitiesListdata: createActivitiesList(activitiesTemplateList),
      });
      this.fetchAllCharts();
    }
  }

  getChartData = (reportName, activityType, baseMarketVal, objIndex) => {
    const { activitiesTemplateList } = this.props;
    const passTargetVal = reportName === SC_COMPETITORS_ACTIVITIES ?
      (baseMarketVal !== undefined && baseMarketVal === SC_TARGET_MARKET) : undefined;
    const activitiesTemplate = reportName === SC_COMPETITORS_ACTIVITIES ||
     reportName === SC_COMPETITORS_COMPARISON ?
      _.find(activitiesTemplateList, o => o.templateName === activityType) : undefined;
    this.props.getCompetitorsBarChartData(reportName, undefined, undefined, undefined,
      passTargetVal, activitiesTemplate, objIndex);
  }

  fetchAllCharts() {
    const { selectedListOptions: { activitiesListDefaults }, activitiesTemplateList,
      baseMarketSelectorVal, scatterplotDefaultCategory } = this.props;
    const scatterplotDfltCatSelected = this.getScatterPlotForGivenFamilyId(scatterplotDefaultCategory);
    let scatterplotDfltCat = scatterplotDfltCatSelected !== undefined ?
      _.find(activitiesTemplateList, o => o.templateName === scatterplotDfltCatSelected.label) :
      activitiesTemplateList[0];
    if (scatterplotDfltCat === undefined) {
      scatterplotDfltCat = activitiesTemplateList[0];
    }
    let activitiesTemplateNames;
    if (_.isEmpty(activitiesListDefaults[0])) {
      activitiesTemplateNames = _.map(activitiesTemplateList, o => o.templateName);
    } else {
      activitiesTemplateNames = _.map(activitiesListDefaults, o => o.label);
    }
    this.getChartData(SC_COMPETITORS);
    if (!_.isEmpty(activitiesTemplateList)) {
      const baseMarketSelectorValSelected = this.getBaseMarketSelectorValForGivenFamilyId(baseMarketSelectorVal);
      this.getChartData(SC_COMPETITORS_ACTIVITIES, scatterplotDfltCat.templateName,
        baseMarketSelectorValSelected);
    }
    if (!_.isEmpty(activitiesTemplateNames)) {
      this.getChartData(SC_COMPETITORS_COMPARISON, activitiesTemplateNames[0], undefined, 0);
      this.getChartData(SC_COMPETITORS_COMPARISON, activitiesTemplateNames[1], undefined, 1);
      this.getChartData(SC_COMPETITORS_COMPARISON, activitiesTemplateNames[2], undefined, 2);
    }
  }

  getScatterPlotForGivenFamilyId = scatterplotDefaultCategory => {
    const { studyInfo } = this.props;
    const studyFamilyId = studyInfo.studyFamilyId;
    let scatterplotDfltCat;
    if (!_.isEmpty(scatterplotDefaultCategory) && scatterplotDefaultCategory !== undefined && _.isArray(scatterplotDefaultCategory)) {
      if (scatterplotDefaultCategory.length > 0) {
        if (scatterplotDefaultCategory[0].studyFamilyId !== undefined) {
          const index = _.findIndex(scatterplotDefaultCategory, { studyFamilyId });
          if (index >= 0) {
            return scatterplotDefaultCategory[index];
          }
        }
      }
    }
    return scatterplotDfltCat;
  }

  getBaseMarketSelectorValForGivenFamilyId = baseMarketSelectorVal => {
    const { studyInfo } = this.props;
    const studyFamilyId = studyInfo.studyFamilyId;
    const baseMarketSelector = 'Universe/Base';
    if (!_.isEmpty(baseMarketSelectorVal) && baseMarketSelectorVal !== undefined && _.isArray(baseMarketSelectorVal)) {
      if (baseMarketSelectorVal.length > 0) {
        if (baseMarketSelectorVal[0].studyFamilyId !== undefined) {
          const index = _.findIndex(baseMarketSelectorVal, { studyFamilyId });
          if (index >= 0) {
            return baseMarketSelectorVal[index].label;
          }
        }
      }
    } else if (!_.isEmpty(baseMarketSelectorVal) && baseMarketSelectorVal !== undefined && !_.isArray(baseMarketSelectorVal)) {
      return baseMarketSelectorVal;
    }
    return baseMarketSelector;
  }

  checkComparisonTableDataEmpty = () => {
    const items = _.reduce(this.state.comparisonTableDataInfo, (count, o) => {
      return _.isEmpty(o) ? count : count + 1;
    }, 0);
    return items > 0;
  }

  render() {
    const { dataSelection } = this.props;
    return (
      <div>
        <div className="sc-panel-width">
          <SalesCatalystCompetitionInput color={this.props.color} />
        </div>
        <div className="row margin-left-0-3 margin-right-0">
          {!_.isEmpty(this.state.columnGraphDataInfo) &&
            <div className="small-12 columns">
              <SalesCatalystCompetitionColumnChart
                data={this.state.columnGraphDataInfo}
                dataSelection={dataSelection}
                baseInfo={this.props.scBase}
                color={this.props.color}
                studyInfo={this.props.studyInfo}
              />
            </div> }
        </div>
        <div className="row margin-left-0-3 margin-right-0">
          {!_.isEmpty(this.state.graphDataInfo) && <div className="small-12 columns">
            <SalesCatalystCompetitionBubbleChart
              data={this.state.graphDataInfo}
              getDataFn={this.getChartData}
              activitiesListData={this.state.activitiesListdata}
              color={this.props.color}
              studyInfo={this.props.studyInfo}
            />
          </div> }
        </div>
        {this.checkComparisonTableDataEmpty() && (!_.isEmpty(dataSelection.targetMarket)
        && !_.isEmpty(dataSelection.entity)) && <div
          className="row margin-left-0-3 margin-right-0"
          style={{ paddingBottom: '1%' }}
        >
          <div className="small-12 columns">
            <SalesCatalystCompetitionComparisonTable
              data={this.state.comparisonTableDataInfo}
              getDataFn={this.getChartData}
              strengthsWeaknessesList={this.state.strengthsWeaknessesList}
              activitiesListData={this.state.activitiesListdata}
            />
          </div>
        </div>}
      </div>
  );
  }
}

SalesCatalystCompetition.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  entityTargetOverlap: PropTypes.string,
  dataSelection: PropTypes.shape({}),
  scBase: PropTypes.shape({}),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    productNo: typeof state.study.salesCatalystStudy !== 'undefined' &&
      typeof state.study.salesCatalystStudy.pn !== 'undefined' ?
      state.study.salesCatalystStudy.pn : 0,
    competitionDataOnScreen: state.salesCatalyst.dataOnScreen.competition,
    dataSelection: state.salesCatalyst.dataSelection,
    bubbleGraphData: state.salesCatalyst.graphData.scCompetitorsActivities,
    comparisonTableData: state.salesCatalyst.graphData.scCompetitorsComparison,
    columnGraphData: state.salesCatalyst.graphData.scCompetitors,
    baseMarketSelectorVal: state.salesCatalyst.scCompetition.baseMarketSelectorVal,
    scatterplotDefaultCategory: state.salesCatalyst.scCompetition.scatterplotDefaultCategory,
    scBase: state.salesCatalyst.salesCatalystBase,
    selectedListOptions: state.salesCatalyst.scCompetition.selectedOptions,
    activitiesTemplateList: state.salesCatalyst.activitiesTemplateList,
    studyInfo: state.study.salesCatalystStudy,
  };
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;

  const getCompetitorsBarChartData = (report, vpctFilter, top,
    minSampleSize, passTargetVal, activitiesTemplate, objIndex) => {
    if (stateProps.dataSelection.entity.length > 0 &&
    stateProps.dataSelection.targetMarket.length > 0 &&
    stateProps.dataSelection.competitor.length > 0) {
      const productNo = stateProps.productNo;
      const token = stateProps.loginResponse.data.token;
      const uid = stateProps.loginResponse.data.uid;
      const accountId = stateProps.activeAccountId;
      const reportName = report;
      const targetLabel = stateProps.dataSelection.targetMarket[0].label;
      const targetExpression = stateProps.dataSelection.targetMarket[0].expression;
      const entityLabel = stateProps.dataSelection.entity[0].label;
      const entityExpression = stateProps.dataSelection.entity[0].expression;
      const brandLabel = undefined;
      const brandExpression = undefined;
      const competitors = _.map(stateProps.dataSelection.competitor, o => ({
        label: o.label,
        expression: o.expression,
      }));

      dispatch(salesCatalystActions.getBarChartReport({
        uid,
        accountId,
        token,
        reportName,
        productNo,
        targetLabel,
        targetExpression,
        entityLabel,
        entityExpression,
        brandLabel,
        brandExpression,
        vpctFilter,
        top,
        minSampleSize,
        competitors,
        passTargetVal,
        activitiesTemplate,
        objIndex,
      }));
    }
  };

  return Object.assign({}, stateProps, ownProps, {
    getCompetitorsBarChartData,
  });
};

export default connect(
  mapStateToProps,
  null,
  mergeProps,
  { forwardRef: true },
)(SalesCatalystCompetition);
